const COMMON_DOMAINS = [
  'gmail.com',
  'yahoo.com',
  'hotmail.com',
  'outlook.com',
  'icloud.com',
  'aol.com',
  'protonmail.com',
  'me.com',
  'msn.com',
  'live.com',
  'comcast.net',
];

function levenshtein(a: string, b: string): number {
  const matrix: number[][] = [];

  for (let i = 0; i <= b.length; i++) matrix[i] = [i];
  for (let j = 0; j <= a.length; j++) matrix[0][j] = j;

  for (let i = 1; i <= b.length; i++) {
    for (let j = 1; j <= a.length; j++) {
      if (b[i - 1] === a[j - 1]) {
        matrix[i][j] = matrix[i - 1][j - 1];
      } else {
        matrix[i][j] = Math.min(
          matrix[i - 1][j - 1] + 1,
          matrix[i][j - 1] + 1,
          matrix[i - 1][j] + 1
        );
      }
    }
  }

  return matrix[b.length][a.length];
}

/**
 * Check if an email domain looks like a typo of a common domain.
 * Returns the corrected email if a likely typo is found, or null otherwise.
 */
export function checkEmailTypo(email: string): string | null {
  const parts = email.split('@');
  if (parts.length !== 2) return null;

  const [local, domain] = parts;
  if (!domain) return null;

  const domainLower = domain.toLowerCase();

  // If it's already a known domain, no suggestion needed
  if (COMMON_DOMAINS.includes(domainLower)) return null;

  let bestMatch: string | null = null;
  let bestDistance = Infinity;

  for (const known of COMMON_DOMAINS) {
    const distance = levenshtein(domainLower, known);
    // Only suggest if distance is 1-2 (close enough to be a typo, but not exact)
    if (distance > 0 && distance <= 2 && distance < bestDistance) {
      bestDistance = distance;
      bestMatch = known;
    }
  }

  if (bestMatch) {
    return `${local}@${bestMatch}`;
  }

  return null;
}
